// @flow
import React, { Component, createRef } from 'react';
import classnames from 'classnames/bind';

import Button from 'Components/Button';
import ConsumptionData from 'Components/ConsumptionData';
import FocusedImage from 'Components/FocusedImage';
import Typography from 'Components/Typography';
import AssetModel from 'Stores/AssetModel';
import { stripTags } from 'Utils';
import { cardTracking } from 'Utils/trackingAttributes';
import styles from './styles.scss';

const cx = classnames.bind(styles);

export type CardProps = {
  link: string,
  headline: {
    forceUppercase?: boolean,
    level: string,
    value: string,
  },
  image: {
    src?: string,
    thumbnails?: {
      '600x600': string,
    },
  },
};

const more = 'Mehr erfahren';

export default class Card extends Component<CardProps> {
  buttonRef = createRef<HTMLButtonElement>(null);

  constructor(props) {
    super(props);

    const imageSrc =
      (props.image && props.image.thumbnails && props.image.thumbnails['600x600']) ||
      (props.image && props.image.src);

    this.asset = createRef();
    this.asset.current = new AssetModel({ ...props, src: imageSrc });

    this.state = {
      showConsumption: false,
    };
  }

  componentDidMount() {
    setTimeout(() => {
      if (!this.state.showConsumption) {
        this.setState({ showConsumption: true });
      }
    }, 2000);
  }

  onClick = (event) => {
    const clickedElementIsButton = this.buttonRef.current.contains(event.target);
    if (clickedElementIsButton || !this.props.link) {
      return;
    }

    this.buttonRef.current.click();
  };

  render() {
    const { link, headline: headlineRaw, title, consumptionText } = this.props;
    const { showConsumption } = this.state;

    // ToDo: remove as soon as all backends deliver headline instead of title
    const headline = title
      ? {
          value: title,
          level: 'h2',
          forceUppercase: true,
        }
      : headlineRaw;

    return (
      <li className={cx('card')}>
        <div className={cx('card-image')}>
          {consumptionText && (
            <ConsumptionData
              ariaLive="assertive"
              actionIcon={showConsumption ? 'close' : 'eco'}
              onClick={() =>
                this.setState((old) => ({
                  showConsumption: !old.showConsumption,
                }))
              }
              consumptionText={[consumptionText]}
              inside="tile"
              style={{
                opacity: +showConsumption,
              }}
              hideCloseButton={true}
            />
          )}
          <FocusedImage image={this.asset.current} useThumb={false} ariaHidden />
        </div>

        <div className={cx('card-action-wrapper')} onClick={this.onClick}>
          <Typography.Headline className={cx('card-title')} {...headline} />
          {link && (
            <Button
              ref={this.buttonRef}
              type="secondary"
              href={link}
              light
              label={more}
              ariaLabel={`${stripTags(headline.value)}: ${more}`}
              additionalProps={cardTracking(more, headline.value)}
            />
          )}
        </div>
      </li>
    );
  }
}
